import { Model } from "@vuex-orm/core";

export interface clientTypeEntity {
  clientTypeId: number;
  clientTypeName: string;
  serviceProviderId?: number | null;
}

export class clientTypeEntity extends Model {
  static entity = "clientTypeEnitity";
  static primaryKey = "clientTypeId";
  static fields() {
    return {
      clientTypeId: this.number(0),
      clientTypeName: this.string(""),
      serviceProviderId: this.number(0).nullable(),
    };
  }
}
